$(document).ready(function(){
  $('#SiteNav li button').on('click', function(e) {
    newURL = window.location.protocol + '//' + window.location.hostname + '/pages/about-us';
    window.location = newURL;
  });
  
  	  var moving__background = $("#moon");

	  $(window).scroll(function() {

	      moving__background.css('margin-top', ($(window).scrollTop())/3); // Parallax scrolling

	      moving__background.css('opacity', 0.5 + ($(window).scrollTop())/moving__background.height()); // Fading out

	  });
  
  const moreText = "Read more";
  const lessText = "Read less";
  const moreButton = $(".readmorebtn");

  moreButton.click(function() {
    const $this = $(this);
    $this.text($this.text() == moreText ? lessText : moreText).parent().next(".more").slideToggle("fast");
  });
  
  // Apply new tab link to Patient referral in utility nav and footer
  $(".utility-nav li:nth-of-type(4) a").attr("target","_blank");
  $(".site-footer-item-align-left small:nth-of-type(4) a").attr("target","_blank");  
  
  // back to top
  jQuery(document).ready(function() {

    var btn = $('#back-to-top');

    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

  });  
  
  
$('.btn-discover').click(function() {
	var getElem = $(this).attr('href');
	var targetDistance = 20;
	if ($(getElem).length) {
		var getOffset = $(getElem).offset().top;
		$('html,body').animate({
			scrollTop: getOffset - targetDistance
		}, 800);
	}
	return false;
});     
});

